import { GridColDef } from "@mui/x-data-grid";

export const columnsLID: GridColDef[] = [
  {
    field: "date_end",
    headerName: "Fecha final toma muestra",
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  {
    field: "sample_reference",
    headerName: "Referencia muestra",
    width: 150,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  {
    field: "client_reference",
    headerName: "Referencia Cliente",
    width: 150,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "sample_type",
    headerName: "Tipo de muestra",
    width: 150,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  {
    field: "analysis_type",
    headerName: "Análisis",
    width: 150,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "isotope",
    headerName: "Isótopo",
    width: 150,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "lid_client",
    headerName: "LID Cliente",
    width: 150,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "lid",
    headerName: "LID Análisis",
    width: 150,
    headerAlign: "center",
    align: "center",
  },
];
